<template>
    <div class="cls-nav" id="cls-nav">
        <div class="cls-nav-div">
            <div class="green_CLSGDB_v2">
                CLSGDB v2
            </div>
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
                <el-menu-item index="home" @click="link('/')">Home</el-menu-item>
                <el-menu-item index="database" @click="link('/database')">Database</el-menu-item>
                <el-menu-item index="mlst" @click="link('/mlst')">MLST</el-menu-item>
                <el-menu-item index="resistome" @click="link('/resistome')">Resistome</el-menu-item>
                <el-menu-item index="mobilome" @click="link('/mobilome')">Mobilome</el-menu-item>
                <el-menu-item index="drivers" @click="link('/drivers')">Drivers</el-menu-item>
                <el-menu-item index="download" @click="link('/download')">Download</el-menu-item>
                <el-menu-item index="contact" @click="link('/contact')">Contact</el-menu-item>
                <!-- <el-menu-item index="home">Home</el-menu-item>
                <el-menu-item index="database">Database</el-menu-item>
                <el-menu-item index="mlst">MLST</el-menu-item>
                <el-menu-item index="resistome">Resistome</el-menu-item>
                <el-menu-item index="mobilome">Mobilome</el-menu-item>
                <el-menu-item index="drivers">Drivers</el-menu-item>
                <el-menu-item index="download">Download</el-menu-item>
                <el-menu-item index="contact">Contact</el-menu-item> -->
            </el-menu>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            // activeIndex: 'home',
        };
    },
    props: {
        activeIndex: {
            type: String,
            default: "home",
        },
    },
    watch: {
        $route: {
            handler(val) {
                this.activeIndex = this.$route.name;
            },
        },
        // deep: true
    },
    methods: {
        handleSelect(key, keyPath) {
            // console.log(key, keyPath);
        },
        link(path, val) {
            if (val) {
                this.$router.push({
                    path: path,
                    query: val,
                });
            } else {
                this.$router.push({
                    path: path,
                });
            }
        },
    }
}
</script>
<style lang="less">
.cls-nav {
    background: #001C66;

    .cls-nav-div {
        width: 1200px;
        margin: 0 auto;
        position: relative;
        height: 60px;

        .green_CLSGDB_v2 {
            width: 161px;
            height: 26px;
            font-size: 26px;
            font-family: Arial-Black, Arial;
            font-weight: 900;
            color: #00C8D7;
            line-height: 26px;
            display: inline-block;
            position: absolute;
            top: 0;
            bottom: 0;
            margin: auto;
        }

        .el-menu.el-menu--horizontal {
            border-bottom: none !important;
            /* display: inline-block; */
            position: absolute;
            top: 0;
            bottom: 0;
            left: 414px;
            margin: auto;

        }

        .el-menu--horizontal>.el-menu-item {
            float: left;
            border-bottom: 3px solid transparent;

            min-width: 63px;
            height: 60px;
            line-height: 60px;
            font-size: 14px;
            font-family: Arial-BoldMT, Arial;
            font-weight: 700;
            font-weight: normal;
            color: #fff;
            opacity: 0.7;
        }

        .el-menu--horizontal>.el-menu-item.is-active {
            opacity: 1;
            background-color: transparent !important;
            border-bottom: 3px solid #00BAC8 !important;
        }

        .el-menu--horizontal>.el-menu-item:not(.is-disabled):focus,
        .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover,
        .el-menu--horizontal>.el-submenu .el-submenu__title:hover {
            background-color: transparent !important;
            color: #fff !important;
        }

        .el-menu {
            background: #001C66;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/common/navmenu.vue